import styled from "styled-components"

export const InfoText = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 33.6px;
  letter-spacing: 1%;
  margin-bottom: 0.5rem;
`

export const StrongText = styled.span`
  font-weight: 600;
`

export const ConversionInfoText = styled.div<{ conversionValue: number }>`
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 33.6px;
  letter-spacing: 1%;
  margin-bottom: 0.5rem;
  color: ${({ conversionValue }) =>
    conversionValue < 1 || !Number.isInteger(conversionValue) ? "red" : "#FF8C42"};
`
